import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Button, Stack, Typography } from '@mui/material';

import { useAppContext } from '../context/AppContext';

const defaultForm = {
  ra_name: '',
  bri_id: '',
};

const RAMappingForm = ({ onSubmit, initialData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { raMapping, getRAMapping, postRAMapping, putRAMapping } = useAppContext();
  const isEditMode = Boolean(id);
  const [form, setForm] = useState(initialData || defaultForm);

  useEffect(() => {
    if (isEditMode) {
      getRAMapping(id);
    }
  }, [id, isEditMode]);

  useEffect(() => {
    if (isEditMode && raMapping && Object.keys(raMapping).length > 0) {
      setForm({
        ra_name: raMapping.ra_name || raMapping.raName || '',
        bri_id: raMapping.bri_id || raMapping.briId || '',
      });
    }
  }, [raMapping, isEditMode]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (isEditMode) {
        await putRAMapping(id, form);
      } else {
        await postRAMapping(form);
      }

      if (onSubmit) {
        onSubmit(form);
      }

      navigate('/ra');
    } catch (err) {
      console.error('Error saving RA mapping:', err);
      alert('Error saving RA mapping');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Typography variant="h6">RA Mapping Form</Typography>
      <Stack spacing={2} direction="column" sx={{ my: 2 }}>
        <TextField
          label="RA Name"
          name="ra_name"
          value={form.ra_name}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="BRI ID"
          name="bri_id"
          value={form.bri_id}
          onChange={handleChange}
          fullWidth
        />
        <Button variant="contained" type="submit" fullWidth>
          {isEditMode ? 'Update RA Mapping' : 'Create RA Mapping'}
        </Button>
      </Stack>
    </form>
  );
};

export default RAMappingForm;
